import { render, staticRenderFns } from "./zhuanjia.vue?vue&type=template&id=86057f22&scoped=true&"
import script from "./zhuanjia.vue?vue&type=script&lang=js&"
export * from "./zhuanjia.vue?vue&type=script&lang=js&"
import style0 from "./zhuanjia.vue?vue&type=style&index=0&id=86057f22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86057f22",
  null
  
)

export default component.exports